import React from "react";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import AssignListTable from "./Componates/AssignListTable";
import { useRoleVerify } from "Common/RoleVerify";
import { NavLink } from "react-router-dom";
import { GetPageUrl } from "utils/CommonUtils";


const EmployeeAssignList = () => {
    const CanAccess = useRoleVerify('', ["can_access", "can_create", "can_edit", "can_delete"])
    const CanEdit = useRoleVerify('', ["can_edit"])
    const page_url = GetPageUrl()

    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Assigned Employee List</HeadingOne>
                    <div className="d-flex flex-wrap gap-2 mt-2">
                        {
                            CanAccess && (
                                <NavLink to="/admin/assigned-roster-list" className={'btn btn-primary'}>Assigned Roster List</NavLink>
                            )
                        }

                        {
                            CanEdit && (
                                <NavLink to={`/admin/${page_url}/assign-employees`} className={'btn btn-primary'}>Assign Employee</NavLink>
                            )
                        }


                    </div>
                </>
            }>

            <AssignListTable />

        </PageBody>
    );
};

export default EmployeeAssignList;